import { useMediaQuery } from 'react-responsive';
import { breakpointNumbers } from '@general/breakpoints';

const { small, medium, large, xLarge } = breakpointNumbers;

export const useScreenXlOnly = () => useMediaQuery({ minWidth: xLarge });
export const useScreenLgOnly = () => useMediaQuery({ minWidth: large, maxWidth: xLarge - 1 });
export const useScreenMdOnly = () => useMediaQuery({ minWidth: medium, maxWidth: large - 1 });
export const useScreenSmOnly = () => useMediaQuery({ minWidth: small, maxWidth: medium - 1 });
export const useScreenXsOnly = () => useMediaQuery({ maxWidth: small - 1 });

export const useScreenMinXl = () => useMediaQuery({ minWidth: xLarge });
export const useScreenMinLg = () => useMediaQuery({ minWidth: large });
export const useScreenMinMd = () => useMediaQuery({ minWidth: medium });
export const useScreenMinSm = () => useMediaQuery({ minWidth: small });

export const useScreenLgDown = () => useMediaQuery({ maxWidth: xLarge - 1 });
export const useScreenMdDown = () => useMediaQuery({ maxWidth: large - 1 });
export const useScreenSmDown = () => useMediaQuery({ maxWidth: medium - 1 });

export const isScreenMinLx = () => ($(window).width() || 0) >= xLarge;
export const isScreenMinLg = () => ($(window).width() || 0) >= large;
export const isScreenMinMd = () => ($(window).width() || 0) >= medium;
export const isScreenMinSm = () => ($(window).width() || 0) >= small;

export const isScreenSmDown = () => ($(window).width() || 0) < medium;
